import axios from "axios";
export default class AuthService {
  login(username, password) {
    let data = {
      password,
      username,
    };
    return axios.post(process.env.VUE_APP_API_PUBLIC + "auth/login", data);
  }
  solicitarCambioPassword(data) {
    return axios.post(
      process.env.VUE_APP_API_PUBLIC + "usuarios/change-password",data
    );
  }
  cambiarPassword(data) {
    return axios.put(
      process.env.VUE_APP_API_PUBLIC + "usuarios/update-password",data
    );
  }
}
